import { Autocomplete, Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Stack, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography } from "@mui/material";
import { Component } from "react";
import { httpGet, httpPost } from "../util/http";
import { MdClose } from "react-icons/md";
import BasicDataGrid from "./BasicDataGrid";
import QtdInput from "./QtdInput";
import CodProdInput from "./CodProdInput";
import DerivInput from "./DerivInput";
import ValorInput from "./ValorInput";
import ProdNomeInput from "./ProdNomeInput";
import BarcodeInput from "./BarcodeInput";

export default class ProdEdit extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            btnLoading: false,
            produto: {},
            codPro: '00000',
            deriv: '',
            showAdd: false,
            notFound: false,
            barcode: '',
            nome: '',
            valor: ''
        };
    }

    componentDidMount() {
        // this.setState({ loading: true });
        // httpGet('/produtos/inventario/' + this.props.inventario?.id,
        //     data => {
        //         console.log(data)
        //         this.setState({
        //             produtos: data,
        //             loading: false,
        //         });
        //     },
        //     error => {
        //         console.log(error);
        //         this.setState({ loading: false });
        //     },
        // );
    }

    search() {
        this.setState({ btnLoading: true, showAdd: false, notFound: false });
        httpGet('/produtos/prod?inventId=' + this.props.inventario?.id + '&codPro=' + this.state.codPro + '&deriv=' + this.state.deriv,
            produto => {
                console.log(produto)
                this.setState({
                    barcode: produto?.barcode,
                    nome: produto?.descricao,
                    marca: produto?.marca,
                    familia: produto?.familia,
                    origem: produto?.origem,
                    valor: produto ? 'R$ ' + produto.valor.replaceAll('.', ',') : '',
                    produto,
                    btnLoading: false,
                    showAdd: true,
                    notFound: false,
                });
            },
            error => {
                console.log(error);
                this.setState({ btnLoading: false, notFound: true });
            }
        );
    }

    salvar() {
        this.setState({ btnLoading: true, showAdd: false, notFound: false });
        httpPost('/produtos/salvar',
            {
                codPro: this.state.codPro,
                deriv: this.state.deriv,
                marca: this.state.marca,
                familia: this.state.familia,
                origem: this.state.origem,
                inventarioId: this.props.inventario?.id,
                barcode: this.state.barcode,
                descr: this.state.nome,
                valor: this.state.valor,
            },
            resp => {
                console.log(resp)
                this.props.onClose();
            },
            error => {
                console.log(error);
                this.setState({ btnLoading: false, showAdd: true });
            }
        );
    }

    render() {
        return (
            <Dialog maxWidth="500px" open={true} sx={{ zIndex: 99999 }}>
                <DialogTitle color="primary" fontSize={12}>AJUSTAR PRODUTO</DialogTitle>
                <IconButton sx={{ position: 'absolute', right: 8, top: 8 }} onClick={e => this.props.onClose(false)}>
                    <MdClose size={18} />
                </IconButton>
                <DialogContent>
                    <Stack minWidth="400px" gap={2}>
                        <Stack direction="row" gap={1} alignItems="center">
                            <CodProdInput value={this.state.codPro} onChange={codPro => this.setState({ codPro })} />
                            <DerivInput value={this.state.deriv} onChange={deriv => this.setState({ deriv })} />
                            {this.state.btnLoading ? <CircularProgress size={20} /> : <Button onClick={() => this.search()} size="small" color="success" variant="contained" disableElevation>Buscar</Button>}
                        </Stack>
                        {this.state.notFound && <Typography color="red" variant="caption">Produto não encontrado.</Typography>}

                        {this.state.showAdd &&
                            <Stack gap={2}>
                                <ProdNomeInput sx={{ flex: 1 }} value={this.state.nome} onChange={nome => this.setState({ nome })} />
                                <Stack direction="row" gap={1}>
                                    <BarcodeInput sx={{ flex: 1 }} value={this.state.barcode} onChange={barcode => this.setState({ barcode })} />
                                    <ValorInput sx={{ flex: 1 }} value={this.state.valor} onChange={valor => this.setState({ valor })} />
                                </Stack>
                            </Stack>
                        }

                    </Stack>
                </DialogContent>
                <DialogActions>
                    {this.state.showAdd && <Button size="small" color="success" onClick={() => this.salvar()}>Salvar</Button>}
                </DialogActions>
            </Dialog>
        );
    }
}